export default "__VITE_ASSET__B5qEDhh2__"